import React from 'react';
import { Checkbox } from '..';

export function RelatedArticleOptions({ options, update }) {
  const handleChanges = (field, value) => {
    update({ [field]: value });
  };

  return (
    <div className="chronos-article-picker-options-menu">
      <div className="chronos-menu-header">Search Options</div>
      <div className="chronos-article-picker-option">
        <label htmlFor="excludeStubs">
          <span className="chronos-article-picker-option-label">
            Exclude Stubs?
          </span>
          <Checkbox
            value={options.excludeStubs}
            onChange={(v) => handleChanges('excludeStubs', v)}
            custom
          />
        </label>
      </div>
      <div className="chronos-article-picker-option">
        <label htmlFor="excludeWIP">
          <span className="chronos-article-picker-option-label">
            Exclude WIP?
          </span>
          <Checkbox
            value={options.excludeWIP}
            onChange={(v) => handleChanges('excludeWIP', v)}
            custom
          />
        </label>
      </div>
      <div className="chronos-article-picker-option">
        <label htmlFor="excludeDrafts">
          <span className="chronos-article-picker-option-label">
            Exclude Drafts?
          </span>
          <Checkbox
            value={options.excludeDrafts}
            onChange={(v) => handleChanges('excludeDrafts', v)}
            custom
          />
        </label>
      </div>
      <div className="chronos-article-picker-option">
        <label htmlFor="excludePrivate">
          <span className="chronos-article-picker-option-label">
            Exclude Private?
          </span>
          <Checkbox
            value={options.excludePrivate}
            onChange={(v) => handleChanges('excludePrivate', v)}
            custom
          />
        </label>
      </div>
    </div>
  );
}
